module.exports = __webpack_public_path__ + "img/document-gray.57dbc5af.svg";